module.exports = __webpack_public_path__ + "static/media/moon.fecac635.svg";